import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const NewsEvents = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">News & Events</h1>
      
      <Tabs defaultValue="news" className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-8">
          <TabsTrigger value="news">Latest News</TabsTrigger>
          <TabsTrigger value="events">Upcoming Events</TabsTrigger>
        </TabsList>

        <TabsContent value="news">
          <div className="grid gap-6">
            <Card>
              <CardHeader>
                <CardTitle>New Guidelines for Medical Practice</CardTitle>
                <p className="text-sm text-muted-foreground">March 15, 2024</p>
              </CardHeader>
              <CardContent>
                <p>MAAP releases updated guidelines for medical practitioners in response to recent healthcare developments.</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Annual Medical Conference Announcement</CardTitle>
                <p className="text-sm text-muted-foreground">March 10, 2024</p>
              </CardHeader>
              <CardContent>
                <p>Save the date for MAAP's Annual Medical Conference 2024, featuring renowned speakers and workshops.</p>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        <TabsContent value="events">
          <div className="grid gap-6">
            <Card>
              <CardHeader>
                <CardTitle>Medical Ethics Workshop</CardTitle>
                <p className="text-sm text-muted-foreground">April 5, 2024</p>
              </CardHeader>
              <CardContent>
                <p>Interactive workshop on medical ethics and professional conduct. Registration now open.</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Healthcare Technology Symposium</CardTitle>
                <p className="text-sm text-muted-foreground">April 15, 2024</p>
              </CardHeader>
              <CardContent>
                <p>Exploring the latest innovations in healthcare technology and their implementation.</p>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default NewsEvents; 